export default "__VITE_ASSET__dc8da3aa__"